module.exports = __webpack_public_path__ + "img/fac.1c0e01ef.png";